import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { TextareaInlineField } from '../../../../Textarea'
import {
  PROVIDER_FORM_DESCRIPTION_FIELD_MAX_LENGTH,
  PROVIDER_FORM_FIELD_NAME_DESCRIPTION,
} from '../../ProviderForm.constants'

function DescriptionField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      clearable
      Component={TextareaInlineField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Provider.DescriptionLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxLength={PROVIDER_FORM_DESCRIPTION_FIELD_MAX_LENGTH}
      name={PROVIDER_FORM_FIELD_NAME_DESCRIPTION}
      placeholder={t('Provider.DescriptionFieldPlaceholderKey')}
    />
  )
}

export default DescriptionField
